import { getFunctions, httpsCallable } from 'firebase/functions';
import app from '../firebase';
import useCoinStore from '../stores/coinStore';
import { freshSession, pendingPurchases, onPurchase } from './vatarClient';

// Our server checks the purchase with Vatar before it grants anything, so this
// is safe to call for any purchase id, any number of times.
export async function claimPurchase(purchaseId) {
  const call = httpsCallable(getFunctions(app), 'vatarClaim');
  const { data } = await call({ session: await freshSession(), purchaseId });
  try {
    await useCoinStore.getState().syncBalance();
  } catch {
    // The grant is already saved; the balance refreshes on the next sync.
  }
  return data;
}

// Claims everything Vatar says is paid but undelivered (reloads, crashes, paying
// in another window) now and whenever a payment lands while the game is away.
// Returns an unsubscribe function.
export function startPurchaseRecovery() {
  const inFlight = new Set();
  const claim = async (p) => {
    const id = p?.purchaseId;
    if (!id || inFlight.has(id)) return;
    inFlight.add(id);
    try {
      await claimPurchase(id);
    } catch (err) {
      // Left undelivered on Vatar's side, so the next start retries it.
      console.warn('[vatar] claim failed, will retry next start:', err?.code || err);
    } finally {
      inFlight.delete(id);
    }
  };

  pendingPurchases().then((list) => list.forEach(claim)).catch(() => {});
  return onPurchase(claim);
}
